import {useLocation} from 'react-router-dom'
import {useState} from 'react'
import {useSharedStore} from '../state/shared-store-context'
import {isAppRoute} from '../shared/app-routes'
import {effect} from '../shared/effect'

export function useAutoscrollStopOnNavigate() {
    const location = useLocation()
    const [prevPathname, setPrevPathname] = useState(location.pathname)
    const {actions} = useSharedStore()

    effect([location.pathname], () => {
        actions.setPortfolioMode(!isAppRoute(location.pathname))
        if (location.pathname !== prevPathname) actions.stopAutoscroll()
        setPrevPathname(location.pathname)
    })
}

